import React, { useEffect, useState } from 'react';
import SelectField from "component/Select/Select";
import ChevronIcon from 'images/circle-chevron-up.svg';
import TrashIcon from 'images/red-trash-icon.svg'
import './ParcelRange.css';

import PropTypes from 'prop-types';
import InputCurrency from 'component/form/InputCurrency';
import DynamicSelectField from 'component/priceBanner/selects/DynamicSelectField';

const ParcelRange = ({
  title,
  onAddAbove,
  onAddBelow,
  canRemove,
  onRemove,
  data,
  onChange,
  errors = {},
  parcelOptions = [],
  user,
  translate,
}) => {

  const [cdParcel, setCdParcel] = useState(data.cdParcel || null);
  const [prMinValue, setMinValue] = useState(data.prMinValue !== undefined ? data.prMinValue : '');
  const [prMaxValue, setMaxValue] = useState(data.prMaxValue || '');
  const [dynamic, setDynamic] = useState(
    data.dynamic
      ? { cdDynamic: data.dynamic.value, dsDynamic: data.dynamic.label }
      : null
  );

  useEffect(() => {
    onChange({
      cdParcel,
      prMinValue,
      prMaxValue,
      dynamic,
    });
  }, [cdParcel, prMinValue, prMaxValue, dynamic]);

  return (
    <div className="parcel-range-container">
      <div className="parcel-range-header">
        <h4>{title}</h4>
        <div className="parcel-range-buttons">
          <button onClick={onAddAbove}>
            <img src={ChevronIcon} alt="Arrow up icon" />
            {translate('price.banner.params.range.add.above')}
          </button>
          <button onClick={onAddBelow}>
            <img src={ChevronIcon} alt="Arrow down icon" className="rotate-down" />
            {translate('price.banner.params.range.add.below')}
          </button>
          {canRemove && (
            <button className='remove-range' onClick={onRemove}>
              <img src={TrashIcon} alt="Trash icon" />
              {translate('price.banner.params.range.delete')}
            </button>
          )}
        </div>
      </div>

      <section className="parcel-range-row">
        <div className="parcel-range-item item--parcel">
          <SelectField
            label={translate('config.pricebannerConfig.form.cdParcelLabel')}
            placeholder="1x"
            value={cdParcel}
            options={parcelOptions}
            required
            validateValue={(value) => !!value && !!value.value}
            errorText={errors.cdParcel ? translate('mandatory') : undefined}
            showHelperArea={false}
            onChange={(value) => setCdParcel(value)}
          />
        </div>

        <div className="parcel-range-item item--price">
          <InputCurrency
            id="prMinValue"
            label={translate('config.pricebannerConfig.form.prMinValue')}
            placeholder="0,00"
            required
            value={prMinValue}
            onChange={e => setMinValue(e.target.value)}
            errorMsg={errors.prMinValue}
          />
        </div>

        <div className="parcel-range-item item--price">
          <InputCurrency
            id="prMaxValue"
            label={translate('config.pricebannerConfig.form.prMaxValue')}
            placeholder="0,00"
            required
            value={prMaxValue}
            onChange={e => setMaxValue(e.target.value)}
            errorMsg={errors.prMaxValue}
          />
        </div>

        <div className="parcel-range-item item--dynamic">
          <DynamicSelectField
            label={translate('config.pricebannerConfig.form.cdNewDynamic')}
            required
            validateValue={(value) => !!value && !!value.value}
            value={dynamic ? { value: dynamic.cdDynamic, label: dynamic.dsDynamic } : null}
            onChange={(selected) => {
              if (!selected) {
                setDynamic(null);
              } else {
                setDynamic({
                  cdDynamic: selected.value,
                  dsDynamic: selected.label,
                });
              }
            }}
            errorText={errors.dynamic ? translate('mandatory') : undefined}
            showHelperArea={false}
            user={user}
            translate={translate}
          />
        </div>
      </section>
    </div>
  )
};

ParcelRange.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  onAddAbove: PropTypes.func,
  onAddBelow: PropTypes.func,
  canRemove: PropTypes.bool,
  onRemove: PropTypes.func,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  parcelOptions: PropTypes.array,
  user: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
};

export default ParcelRange;
